import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { environment } from '../../../../environments/environment';
import { ConnectionHubStoreModelGroup } from '../../_models/connection-hub/connection-hub';

@Injectable()
export class ConnectionHubService {
  private apiBaseUrl = environment.connectionHubServiceUrl;
  public $storeModelGroups: BehaviorSubject<ConnectionHubStoreModelGroup[]> = new BehaviorSubject<
    ConnectionHubStoreModelGroup[]
  >([]);

  // services
  private http = inject(HttpClient);

  constructor() {}

  /**
   * Gets the list of current providers providing connection status for each
   * @returns {Observable<ConnectionHubStoreModelGroup[]>}
   * @memberof NutritionService
   * @method getProvidersStatus
   * @public
   * @return {Observable<ConnectionHubStoreModelGroup[]>}
   */
  getProvidersStatus(): Observable<ConnectionHubStoreModelGroup[]> {
    return this.http
      .get<ConnectionHubStoreModelGroup[]>(this.apiBaseUrl + 'api/private/v1/storeModelGroups')
      .pipe(map((response) => response));
  }

  /**
   * Gets the list of current providers providing connection status for each and stores it in a BehaviorSubject
   * @returns {Observable<ConnectionHubStoreModelGroup[]>}
   * @memberof NutritionService
   * @method getProvidersStatus
   * @public
   * @return {Observable<ConnectionHubStoreModelGroup[]>}
   */
  getAndStoreProvidersStatus(): Observable<ConnectionHubStoreModelGroup[]> {
    return this.http
      .get<ConnectionHubStoreModelGroup[]>(this.apiBaseUrl + 'api/private/v1/storeModelGroups')
      .pipe(
        map((response) => {
          this.$storeModelGroups.next(response);
          return response;
        })
      );
  }

  /**
   * Gets the status of a specific provider
   * @param providerCode
   * @returns {Observable<ConnectionHubStoreModelGroup>}
   * @memberof NutritionService
   * @method getProviderStatus
   * @public
   */
  getProviderStatus(providerCode: string): Observable<ConnectionHubStoreModelGroup> {
    return this.http
      .get<ConnectionHubStoreModelGroup>(
        this.apiBaseUrl + 'api/private/v1/storeModelGroups/' + providerCode
      )
      .pipe(map((response) => response));
  }

  disconnectProvider(provider: ConnectionHubStoreModelGroup): Observable<void> {
    return this.http
      .get<void>(
        this.apiBaseUrl + 'api/private/v1/storeModelGroups/' + provider.code + '/disconnect'
      )
      .pipe(map((response) => response));
  }
}
